module.exports = __webpack_public_path__ + "img/smallLogo.5460db44.svg";